<template>
  <div v-if="show" role="alert" class="alert fade alert-danger show">
    <div class="alert-text">
      {{ text || $t("GENERAL.GENERAL_ERROR") }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean
    },
    text: {
      type: String,
      default() {
        return null;
      }
    }
  }
};
</script>
